import React from 'react';
import { ButtonWrapper, TabLineButton } from '../../../styles/button.style';
import { useTankCleaningStore } from '../../../context/TankCleaningContext';
import usePostUpdateChemicalOrder from '../../../api/usePostUpdateChemicalOrder';
import mapTankCleaningUtils from '../../../utils/mapTankCleaningUtils';
import { useVesselStore } from '../../../context/VesselContext';
import { UpdateOrderStatusEnum } from '../../../enums/updateOrderStatusEnum';
import { RoleTypeEnum } from '../../../enums/roleTypeEnum';
import { useAuthStore } from '../../../context/AuthContext';
import { ChemicalOrderStatusEnum } from '../../../enums/chemicalOrderStatusEnum';
import { useToast } from '../../../app/useToast';

const SaveButtonManagerForOrderComponent: React.FC = () => {
    const { isNewOrder, setIsNewOrder, selectedTankCleaningPortCall, chemicalOrderUpdateReportData } = useTankCleaningStore();
    const { selectedVessel } = useVesselStore();
    const { getChemicalOrderForPortCallBM } = mapTankCleaningUtils();
    const { upsertChemicalOrder } = usePostUpdateChemicalOrder();
    const { role, loggedInUser } = useAuthStore();
    const { toastError } = useToast();
    const { deleteChemicalOrderDraft } = usePostUpdateChemicalOrder();

    // ========== USE EFFECTS ===========

    const onSaveOrder = () => {
        if (role && chemicalOrderUpdateReportData && selectedTankCleaningPortCall && selectedTankCleaningPortCall.portCallId && selectedVessel) {
            const chemicalOrderForPortCallBM = getChemicalOrderForPortCallBM(chemicalOrderUpdateReportData, selectedTankCleaningPortCall);

            if (
                role &&
                role.roleType === RoleTypeEnum.ShipUser &&
                chemicalOrderForPortCallBM.lastOrderStatusId === ChemicalOrderStatusEnum.SentToOperator
            ) {
                chemicalOrderForPortCallBM.updateOrderStatusId = UpdateOrderStatusEnum.UpdatedByShip;
            } else if (
                role &&
                (role.roleType === RoleTypeEnum.ShipOperator || role.roleType === RoleTypeEnum.Admin) &&
                (chemicalOrderForPortCallBM.lastOrderStatusId === ChemicalOrderStatusEnum.SentToOperator ||
                    chemicalOrderForPortCallBM.lastOrderStatusId === ChemicalOrderStatusEnum.Ordered)
            ) {
                chemicalOrderForPortCallBM.updateOrderStatusId = UpdateOrderStatusEnum.UpdatedByOperator;
            }

            if (chemicalOrderForPortCallBM.lastOrderStatusId === ChemicalOrderStatusEnum.Unsaved) {
                chemicalOrderForPortCallBM.lastOrderStatusId = ChemicalOrderStatusEnum.Draft;
            }

            if (chemicalOrderForPortCallBM.chemicalOrderItemList.length > 0) {
                upsertChemicalOrder(chemicalOrderForPortCallBM, selectedVessel?.imoNumber);
            } else {
                toastError('No items to save');
            }
        }
        setIsNewOrder(false);
    };

    const onDeleteDraft = (chemicalOrderId: number) => {
        if (role && chemicalOrderUpdateReportData && selectedTankCleaningPortCall && selectedTankCleaningPortCall.portCallId && selectedVessel) {
            deleteChemicalOrderDraft(selectedVessel.imoNumber, chemicalOrderId);
        }
    };

    const showCancelNewOrderButton = () => {
        if (isNewOrder) {
            return <TabLineButton onClick={onCancelNewOrder}>Cancel</TabLineButton>;
        }
    };

    const onCancelNewOrder = () => {
        setIsNewOrder(false);
        window.location.reload();
    };

    const showSaveOrderButton = () => {
        if (role.roleType === RoleTypeEnum.ShipUser && chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.Unsaved) {
            return (
                <TabLineButton type="button" className="primary-btn" disabled={false} onClick={() => onSaveOrder()}>
                    Save
                </TabLineButton>
            );
        } else if (
            (role.roleType === RoleTypeEnum.Admin || role.roleType === RoleTypeEnum.ShipUser || role.roleType === RoleTypeEnum.ShipOperator) &&
            chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.Draft
        ) {
            return (
                <>
                    <TabLineButton
                        type="button"
                        className="primary-btn"
                        disabled={false}
                        onClick={() => onDeleteDraft(chemicalOrderUpdateReportData.chemicalOrderId)}
                    >
                        Delete
                    </TabLineButton>
                    <TabLineButton type="button" className="primary-btn" disabled={false} onClick={() => onSaveOrder()}>
                        Save
                    </TabLineButton>
                </>
            );
        } else if (
            (role.roleType === RoleTypeEnum.Admin || role.roleType === RoleTypeEnum.ShipOperator) &&
            chemicalOrderUpdateReportData?.lastOrderStatusId !== ChemicalOrderStatusEnum.Canceled &&
            chemicalOrderUpdateReportData?.lastOrderStatusId !== ChemicalOrderStatusEnum.Confirmed
        ) {
            return (
                <TabLineButton type="button" className="primary-btn" disabled={false} onClick={() => onSaveOrder()}>
                    Save
                </TabLineButton>
            );
        } else if (
            role.roleType === RoleTypeEnum.ShipOperator &&
            chemicalOrderUpdateReportData?.lastOrderStatusId === ChemicalOrderStatusEnum.Draft &&
            chemicalOrderUpdateReportData.createdBy === loggedInUser?.userName
        ) {
            return (
                <TabLineButton type="button" className="primary-btn" disabled={false} onClick={() => onSaveOrder()}>
                    Save
                </TabLineButton>
            );
        }
    };

    return (
        <ButtonWrapper>
            {showCancelNewOrderButton()}
            {showSaveOrderButton()}
        </ButtonWrapper>
    );
};

export default SaveButtonManagerForOrderComponent;
